<template>
  <div>
    <a-row :gutter="16">
      <a-col :span="12">
        <a-card :body-style="{ padding: 0 }">
          <span slot="title">待办事项（{{ taskList.length }}）</span>
          <div style="height: 455px">
            <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="taskLoading" :data-source="taskList" :scroll="{ y: 417 }" rowKey="uid">
              <a-table-column title="待办事项" data-index="taskName" :width="170" :ellipsis="true" align="left" :sorter="(a, b) => b.taskType - a.taskType" :sort-directions="['descend', 'ascend']">
                <template slot-scope="text, record">
                  <template v-if="record.taskType == 2001">协同用户审核</template>
                  <template v-else-if="record.taskType == 3001">项目申请单预审</template>
                  <template v-else>
                    <template v-if="record.taskType === 1">项目评审</template>
                    <template v-else-if="record.taskType === 2">筹款申请审核</template>
                    <template v-else-if="record.taskType === 3">项目预算审核<span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span></template>
                    <template v-else-if="record.taskType === 31">填报项目预算<span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span></template>
                    <template v-else-if="record.taskType === 4">项目计划审核</template>
                    <template v-else-if="record.taskType === 41">填报项目计划<span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span></template>
                    <template v-else-if="record.taskType === 5">
                      <a-tag class="tag-tiny v-mr-xs" color="red">{{ record.items.length }}</a-tag>计划成果待审核
                    </template>
                    <template v-else-if="record.taskType === 51">
                      <a-tag class="tag-tiny v-mr-xs" color="red">{{ record.items.length }}</a-tag>计划成果待提交
                    </template>
                    <template v-else-if="record.taskType === 6">
                      <template v-if="record.itemState == 0">提交请款单</template>
                      <template v-else>请款单审核</template>
                      <span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span>
                    </template>
                    <template v-else-if="record.taskType === 7">
                      <template v-if="record.itemState == 0">提交财务进展</template>
                      <template v-else>财务进展审核</template>
                      <span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span>
                    </template>
                    <template v-else-if="record.taskType === 8">
                      <template v-if="record.itemState == 0">提交项目报告</template>
                      <template v-else>项目报告审核</template>
                      <span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span>
                    </template>
                    <template v-else-if="record.taskType === 9">
                      <template v-if="record.changeType == 1">
                        <template v-if="record.itemState == 0">提交项目周期变更</template>
                        <template v-else>项目周期变更审核</template>
                      </template>
                      <template v-else-if="record.changeType == 2">
                        <template v-if="record.itemState == 0">提交项目预算变更</template>
                        <template v-else>项目预算变更审核</template>
                      </template>
                      <template v-else-if="record.changeType == 3">
                        <template v-if="record.itemState == 0">提交项目计划变更</template>
                        <template v-else>项目计划变更审核</template>
                      </template>
                      <span class="text-red" v-if="record.taskCheckResult == -1">(驳回)</span>
                    </template>
                    <template v-else-if="record.taskType === 10">
                      <template v-if="record.projectType == 21">上传项目协议</template>
                      <template v-else-if="record.projectType == 22">上传项目协议</template>
                      <template v-else-if="record.projectType == 24">上传咨询确认书</template>
                    </template>
                  </template>
                </template>
              </a-table-column>
              <a-table-column title="事项类型" data-index="projectType" :width="94" align="left" :sorter="(a, b) => b.projectType - a.projectType" :sort-directions="['descend', 'ascend']">
                <template slot-scope="text, record">
                  <template v-if="record.taskType == 2001">协同用户</template>
                  <template v-else-if="record.taskType == 3001">项目申请单</template>
                  <template v-else>
                    <span v-if="text === 11">公募合作</span>
                    <span v-else-if="text === 12">专项基金</span>
                    <span v-else-if="text === 21">螺蛳壳改造</span>
                    <span v-else-if="text === 22">精灵书屋</span>
                    <span v-else-if="text === 23">公益人才</span>
                    <span v-else-if="text === 24">爱心100</span>
                    <span v-else-if="text === 25">其他项目</span>
                  </template>
                </template>
              </a-table-column>
              <a-table-column title="事项目标（项目/用户/申请单）" data-index="projectName" :ellipsis="true" align="left" :sorter="(a, b) => b.projectName.localeCompare(a.projectName)" :sort-directions="['descend', 'ascend']" :filters="taskProjects.map(name => ({ text: name, value: name }))" @filter="(value, record) => record.projectName == value">
                <template slot-scope="text">
                  <span :title="text">{{ text }}</span>
                </template>
              </a-table-column>
              <a-table-column title="创建时间" data-index="taskTime" :width="130" align="left" :sorter="(a, b) => b.taskTime && a.taskTime ? a.taskTime.localeCompare(b.taskTime) : b.taskTime ? -1 : 1" :sort-directions="['ascend', 'descend']">
                <template slot-scope="text">
                  {{ text ? text.substring(0, 16) : '' }}
                </template>
              </a-table-column>
              <a-table-column title="操作" data-index="action" :width="55" align="center">
                <template slot-scope="text, record">
                  <span class="hover-line text-indigo" @click="$router.push(`/project/applicant/check?id=${record.targetId}`)" v-if="record.taskType == 2001">处理</span>
                  <span class="hover-line text-indigo" @click="$router.push(`/project/lingxi/view?id=${record.formId}`)" v-if="record.taskType == 3001">处理</span>
                  <template v-else-if="record.taskType === 1">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/review?id=${record.projectId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/house/review?id=${record.projectId}`)" v-else-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/school/review?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/talent/review?id=${record.projectId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/love/review?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/review?id=${record.projectId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 2">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/view/raise?id=${record.projectId}`)">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 3">
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/budget/review?id=${record.projectId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/budget/review?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/budget/review?id=${record.projectId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/budget/review?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/budget/review?id=${record.projectId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 31">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/budget/draft?id=${record.projectId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/budget/draft?id=${record.projectId}`)" v-else-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/budget/draft?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/budget/draft?id=${record.projectId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/budget/draft?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/budget/draft?id=${record.projectId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 4">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/plan/review?id=${record.projectId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/plan/review?id=${record.projectId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/plan/review?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/plan/review?id=${record.projectId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/plan/review?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/plan/review?id=${record.projectId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 41">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/plan/review?id=${record.projectId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/plan/draft?id=${record.projectId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/plan/draft?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/plan/draft?id=${record.projectId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/plan/draft?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/plan/draft?id=${record.projectId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 5 || record.taskType === 51">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/view/plan?id=${record.projectId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/view/plan?id=${record.projectId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/view/plan?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/view/plan?id=${record.projectId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/view/plan?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/view/plan?id=${record.projectId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 6">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/applyBill/review?id=${record.projectId}&aid=${record.itemId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/applyBill/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&aid=${record.itemId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/applyBill/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&aid=${record.itemId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/applyBill/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&aid=${record.itemId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/applyBill/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&aid=${record.itemId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/applyBill/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&aid=${record.itemId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 7">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/progress/review?id=${record.projectId}&bid=${record.itemId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/progress/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&bid=${record.itemId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/progress/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&bid=${record.itemId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/progress/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&bid=${record.itemId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/progress/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&bid=${record.itemId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/progress/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&bid=${record.itemId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 8">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/report/review?id=${record.projectId}&rid=${record.itemId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/report/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&rid=${record.itemId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/report/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&rid=${record.itemId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/report/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&rid=${record.itemId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/report/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&rid=${record.itemId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/report/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&rid=${record.itemId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 9">
                    <span class="hover-line text-indigo" @click="$router.push(`project/funded/changeinfo/review?id=${record.projectId}&cid=${record.itemId}`)" v-if="record.projectCate == 1">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/house/changeinfo/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&cid=${record.itemId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/school/changeinfo/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&cid=${record.itemId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/talent/changeinfo/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&cid=${record.itemId}`)" v-else-if="record.projectType == 23">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/${record.isMain ? 'main' : 'own'}/love/changeinfo/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&cid=${record.itemId}`)" v-else-if="record.projectType == 24">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/main/other/changeinfo/${ record.itemState == 0 ? 'draft' : 'review' }?id=${record.projectId}&cid=${record.itemId}`)" v-else-if="record.projectType == 25">处理</span>
                  </template>
                  <template v-else-if="record.taskType === 10">
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/house/contract?id=${record.projectId}`)" v-if="record.projectType == 21">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/school/contract?id=${record.projectId}`)" v-else-if="record.projectType == 22">处理</span>
                    <span class="hover-line text-indigo" @click="$router.push(`project/own/love/contract?id=${record.projectId}`)" v-else-if="record.projectType == 24">处理</span>
                  </template>
                </template>
              </a-table-column>
            </a-table>
          </div>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="我的任务日历" :body-style="{ padding: 0 }">
          <a-calendar :header-render="headerRender" @panelChange="onCalendarPanelChange">
            <div class="text-right" slot="dateCellRender" slot-scope="value">
              <!-- <a-badge class="ant-badge-square" :text="undefined" color="#cc0504" v-if="calendarData[value.format('YYYY-MM-DD')] && calendarData[value.format('YYYY-MM-DD')][1]" /> -->
              <!-- <a-badge class="ant-badge-square" :text="undefined" color="#3f51b5" v-if="calendarData[value.format('YYYY-MM-DD')] && calendarData[value.format('YYYY-MM-DD')][2]" /> -->
              <a-space v-if="calendarData[value.format('YYYY-MM-DD')]">
                <a-tooltip placement="left" v-if="calendarData[value.format('YYYY-MM-DD')][1]">
                  <template slot="title">
                    <span>{{ value.format('YYYY年MM月DD日') }}有{{ calendarData[value.format('YYYY-MM-DD')][1].length }}个任务到期</span>
                  </template>
                  <a-tag color="#cc0504" class="tag-tiny v-mr-none">{{ calendarData[value.format('YYYY-MM-DD')][1].length }}</a-tag>
                </a-tooltip>
                <a-tooltip placement="left" v-if="calendarData[value.format('YYYY-MM-DD')][2]">
                  <template slot="title">
                    <span>{{ value.format('YYYY年MM月DD日') }}有{{ calendarData[value.format('YYYY-MM-DD')][2].length }}个会议需要参与</span>
                  </template>
                  <a-tag color="#3f51b5" class="tag-tiny v-mr-none">{{ calendarData[value.format('YYYY-MM-DD')][2].length }}</a-tag>
                </a-tooltip>
              </a-space>
              <!-- <a-badge class="ant-badge-square" :text="undefined" color="#ff9800" v-else-if="getState(value) == 0" /> -->
              <!-- <a-badge class="ant-badge-square" :text="undefined" color="#87d068" v-else-if="getState(value) == 1 || getState(value) == 2" /> -->
            </div>
          </a-calendar>
        </a-card>
      </a-col>
    </a-row>
    <a-row class="v-my-md" :gutter="16">
      <a-col :span="12">
        <a-card title="筹款金额统计">
          <a-select size="small" v-model="year1" slot="extra" :dropdown-match-select-width="false">
            <a-select-option v-for="(item, index) in years1" :key="item">
              {{ item }}年
              <template v-if="index == 0">以来</template>
            </a-select-option>
          </a-select>
          <div class="stat-container">
            <div class="info-stat justify-around" style="height: 200px">
              <div class="stat-item">
                <div ref="noReview" class="stat-value">
                  <span class="text-red" ref="contractAmountAll">{{ $utils.thousands(statinfo1.total) }}</span>
                  <i>元</i>
                </div>
                <div class="stat-field">筹款金额合计</div>
              </div>
              <div class="stat-item2" style="width: 220px">
                <a-statistic :precision="2" :value="statinfo1.amount0">
                  <div class="flex items-center justify-end" slot="title">
                    <a-icon type="alipay-circle" class="text-blue v-mr-xs" />
                    支付宝筹款
                  </div>
                  <i slot="suffix" class="font-xs text-grey">元</i>
                </a-statistic>
                <a-statistic :precision="2" :value="statinfo1.amount1" class="v-my-sm">
                  <div class="flex items-center justify-end" slot="title">
                    <a-icon type="wechat" class="text-green v-mr-xs" />
                    微信筹款
                  </div>
                  <i slot="suffix" class="font-xs text-grey">元</i>
                </a-statistic>
                <a-statistic :precision="2" :value="statinfo1.amount9">
                  <div class="flex items-center justify-end" slot="title">
                    <i class="text-orange fa fa-cubes v-mr-xs" />
                    银行转账捐赠
                  </div>
                  <i slot="suffix" class="font-xs text-grey">元</i>
                </a-statistic>
              </div>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="项目预算金额">
          <a-select size="small" v-model="year2" slot="extra" :dropdown-match-select-width="false">
            <a-select-option v-for="(item, index) in years2" :key="item">
              {{ item }}年
              <template v-if="index == 0">以来</template>
            </a-select-option>
          </a-select>
          <div class="info-stat justify-around v-px-md" style="height: 200px">
            <div class="stat-item">
              <div ref="noReview" class="stat-value text-primary">
                <span class="text-red" ref="projectAmountAll">{{ $utils.thousands(statinfo2.total) }}</span>
                <i>元</i>
              </div>
              <div class="stat-field">项目预算金额合计</div>
            </div>
            <div class="stat-item2">
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">公募合作项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount11">{{ $utils.thousands(statinfo2.amount11) }}</span>
                  <i>元</i>
                </div>
              </div>
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">专项基金项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount12">{{ $utils.thousands(statinfo2.amount12) }}</span>
                  <i>元</i>
                </div>
              </div>
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">螺蛳壳改造项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount21">{{ $utils.thousands(statinfo2.amount21) }}</span>
                  <i>元</i>
                </div>
              </div>
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">精灵书屋项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount22">{{ $utils.thousands(statinfo2.amount22) }}</span>
                  <i>元</i>
                </div>
              </div>
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">公益人才项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount23">{{ $utils.thousands(statinfo2.amount23) }}</span>
                  <i>元</i>
                </div>
              </div>
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">爱心100项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount24">{{ $utils.thousands(statinfo2.amount24) }}</span>
                  <i>元</i>
                </div>
              </div>
              <div class="flex items-center">
                <div class="stat-field v-mr-xs text-left">其他项目项目金额</div>
                <div ref="noReview" class="stat-value text-indigo" style="margin-top: -4px; width: 120px; text-align: left">
                  <span style="font-size: 16px" ref="amount25">{{ $utils.thousands(statinfo2.amount25) }}</span>
                  <i>元</i>
                </div>
              </div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card :body-style="{ padding: 0 }">
          <span slot="title">执行项目清单（{{ projectList.length }}）</span>
          <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="projectLoading" :data-source="projectList" :scroll="{ x: '100%' }" rowKey="id">
            <a-table-column title="#" data-index="index" :width="55" align="center">
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column title="项目名称" data-index="name" :ellipsis="true" align="left">
              <template slot-scope="text, record">
                <router-link class="hover-line text-indigo" :title="text" :to="{ path: 'project/funded/view', query: { id: record.id } }" v-if="record.cate == 1">{{ text }}</router-link>
                <router-link class="hover-line text-indigo" :title="text" :to="{ path: 'project/own/house/view', query: { id: record.id } }" v-else-if="record.type == 21">{{ text }}</router-link>
                <router-link class="hover-line text-indigo" :title="text" :to="{ path: 'project/own/school/view', query: { id: record.id } }" v-else-if="record.type == 22">{{ text }}</router-link>
                <router-link class="hover-line text-indigo" :title="text" :to="{ path: 'project/own/talent/view', query: { id: record.id } }" v-else-if="record.type == 23">{{ text }}</router-link>
                <router-link class="hover-line text-indigo" :title="text" :to="{ path: 'project/own/love/view', query: { id: record.id } }" v-else-if="record.type == 24">{{ text }}</router-link>
                <router-link class="hover-line text-indigo" :title="text" :to="{ path: 'project/own/other/view', query: { id: record.id } }" v-else-if="record.type == 25">{{ text }}</router-link>
              </template>
            </a-table-column>
            <a-table-column title="项目状态" data-index="state" :width="80" align="center">
              <template slot-scope="text" v-if="text == 7">执行中</template>
            </a-table-column>
            <a-table-column title="项目分类" data-index="cate" :width="80" align="left">
              <template slot-scope="text">
                <span v-if="text === 1">合作项目</span>
                <span v-else-if="text === 2">自有项目</span>
              </template>
            </a-table-column>
            <a-table-column title="项目类型" data-index="type" :width="90" align="left">
              <template slot-scope="text">
                <span v-if="text === 11">公募合作</span>
                <span v-else-if="text === 12">专项基金</span>
                <span v-else-if="text === 21">螺蛳壳改造</span>
                <span v-else-if="text === 22">精灵书屋</span>
                <span v-else-if="text === 23">公益人才</span>
                <span v-else-if="text === 24">爱心100</span>
                <span v-else-if="text === 25">其他项目</span>
              </template>
            </a-table-column>
            <a-table-column title="项目实施周期" data-index="range" :width="180" align="left">
              <template slot-scope="text, record">
                <span>
                  {{ record.startDate ? record.startDate.substring(0, 10) : '' }}
                  <template v-if="record.endDate">~ {{ record.endDate.substring(0, 10) }}</template>
                </span>
              </template>
            </a-table-column>
            <a-table-column title="预算金额" data-index="budgetAmount" :width="115" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.budgetAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="请款金额" data-index="appliedAmount" :width="115" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.appliedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="实际支出金额" data-index="expensedAmount" :width="115" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.expensedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="请款余额" data-index="remainApplyAmount" :width="115" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.appliedAmount - record.expensedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="差额" data-index="remainAmount" :width="115" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.budgetAmount - record.appliedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="项目负责人" data-index="supervisor" :ellipsis="true" :width="90" align="left" />
            <a-table-column title="负责人电话" data-index="supervisorPhone" :ellipsis="true" :width="110" align="left" />
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { listOngoing } from '@/api/project/common'
import { listTodoTasks, listCalendarTask } from '@/api/system/user'
import { statRaiseYears, statRaiseAmountByYear, statProjectYears, statProjectAmountByYear } from '@/api/stat'
import gsap from 'gsap'
export default {
  name: 'ProjectDashboard',
  data() {
    return {
      projectLoading: false,
      taskLoading: false,
      statLoading: false,
      projAmountLoading: false,
      raiseAmountLoading: false,
      currentMonth: new Date().getMonth(),
      currentDate: this.$moment(),
      calendarData: {},
      projectStats: {},
      subjectChartOption: {},
      districtChartOption: {},
      taskList: [],
      projectList: [],
      years1: [],
      years2: [],
      year1: undefined,
      year2: undefined,
      statinfo1: {
        total: 0,
        amount0: 0,
        amount1: 0,
        amount2: 0,
        amount3: 0,
        amount9: 0,
      },
      statinfo2: {
        total: 0,
        amount11: 0,
        amount12: 0,
        amount21: 0,
        amount22: 0,
        amount23: 0,
        amount24: 0,
        amount25: 0,
      },
      taskProjects: [],
      showYearPanel: false,
    }
  },
  watch: {
    year1() {
      this.loadStatRaiseAmountByYear()
    },
    year2() {
      this.loadStatProjectAmountByYear()
    },
  },
  methods: {
    init() {
      this.loadTasks()
      this.loadProjects()
      this.loadStatRaiseYears()
      this.loadStatProjectYears()
      this.loadCalendarData()
      // this.loadStatDashboard()
    },
    loadTasks() {
      this.taskLoading = true
      listTodoTasks().then(({ data }) => {
        if (data.success) {
          // let list = data.result.map((task, key) => Object.assign({ key }, task))
          // list.sort((a, b) => {
          //   return new Date(a.date).getTime() - new Date(b.date).getTime()
          // })
          let list = data.result
          let projects = new Set()
          list.forEach(d => {
            if (d.taskType == 51) {
              let taskTime = null
              d.items.forEach(({ itemTime }) => {
                if (itemTime && (!taskTime || new Date(taskTime).getTime() > new Date(itemTime).getTime())) {
                  taskTime = itemTime
                }
              })
              projects.add(d.projectName)
              d.taskTime = taskTime
            }
            d.uid = Math.random()
          })
          this.taskProjects = [...projects]
          list.sort((a, b) => {
            return a.taskTime && b.taskTime ? new Date(b.taskTime).getTime() - new Date(a.taskTime).getTime() : b.taskTime ? 1 : -1
          })
          this.taskList = list
        }
        this.taskLoading = false
      })
    },
    loadCalendarData(date) {
      date = date || this.$moment()
      let startDate = date.clone().startOf('month').add(-7, 'days').format('YYYY-MM-DD')
      let endDate = date.clone().endOf('month').add(14, 'days').format('YYYY-MM-DD')
      listCalendarTask({ startDate, endDate }).then(({ data }) => {
        if (data.success) {
          let dataMap = {}
          data.result.forEach(item => {
            let { date, type } = item
            if (!dataMap[date]) {
              dataMap[date] = {}
            }
            if (!dataMap[date][type]) {
              dataMap[date][type] = []
            }
            dataMap[date][type].push(item)
          })
          this.calendarData = dataMap
        }
      })
    },
    loadProjects() {
      this.projectLoading = false
      listOngoing().then(({ data }) => {
        if (data.success) {
          this.projectList = data.result
        }
        this.projectLoading = false
      })
    },
    loadStatRaiseYears() {
      statRaiseYears().then(({ data }) => {
        if (data.success) {
          this.years1 = data.result
          this.year1 = data.result[0]
        }
      })
    },
    loadStatProjectYears() {
      statProjectYears().then(({ data }) => {
        if (data.success) {
          this.years2 = data.result
          this.year2 = data.result[0]
        }
      })
    },
    loadStatProjectAmountByYear() {
      this.projAmountLoading = true
      statProjectAmountByYear(this.year2).then(({ data }) => {
        if (data.success) {
          let result = data.result.reduce((value, cur) => ({ ...value, [cur.type]: cur }), {})
          gsap.to(this.statinfo2, 0.5, {
            total: data.result.reduce((prev, cur) => prev + cur.budget_amount, 0),
            amount11: result[11] ? result[11].budget_amount : 0,
            amount12: result[12] ? result[12].budget_amount : 0,
            amount21: result[21] ? result[21].budget_amount : 0,
            amount22: result[22] ? result[22].budget_amount : 0,
            amount23: result[23] ? result[23].budget_amount : 0,
            amount24: result[24] ? result[24].budget_amount : 0,
            amount25: result[25] ? result[25].budget_amount : 0,
          })
        }
        this.projAmountLoading = false
      })
    },
    loadStatRaiseAmountByYear() {
      this.raiseAmountLoading = true
      statRaiseAmountByYear(this.year1).then(({ data }) => {
        if (data.success) {
          let result = data.result.reduce((value, cur) => ({ ...value, [cur.type]: cur }), {})
          gsap.to(this.statinfo1, 0.5, {
            total: data.result.reduce((prev, cur) => prev + cur.amount, 0),
            amount0: result[0] ? result[0].amount : 0,
            amount1: result[1] ? result[1].amount : 0,
            amount2: result[2] ? result[2].amount : 0,
            amount9: result[9] ? result[9].amount : 0,
          })
        }
        this.raiseAmountLoading = false
      })
    },
    onCalendarPanelChange(date, mode) {
      if (mode === 'month') {
        this.currentMonth = date.get('month')
        this.loadCalendarData(date)
      }
    },
    // onDateChange(date) {
    //   this.currentDay = date
    //   this.loadDailyDetail()
    // },
    headerRender({ value, type, onChange, onTypeChange }) {
      let vm = this
      const start = 0
      const end = 12
      const monthOptions = []

      const current = value.clone()
      const localeData = value.localeData()
      const months = []
      for (let i = 0; i < 12; i++) {
        current.month(i)
        months.push(localeData.monthsShort(current))
      }

      for (let index = start; index < end; index++) {
        monthOptions.push(
          <a-select-option class="month-item" key={`${index}`}>
            {months[index]}
          </a-select-option>
        )
      }
      const month = value.month()

      const year = value.year()
      const options = []
      for (let i = year - 10; i < year + 10; i += 1) {
        options.push(
          <a-select-option key={i} value={i} class="year-item">
            {i}年
          </a-select-option>
        )
      }
      // <a-select
      //   size="small"
      //   dropdownMatchSelectWidth={false}
      //   class="my-year-select"
      //   onChange={newYear => {
      //     const now = value.clone().year(newYear)
      //     onChange(now)
      //   }}
      //   value={String(year) + '年'}>
      //   {options}
      // </a-select>
      return (
        <div style={{ padding: '10px 16px 10px 16px' }} class="flex items-center">
          <a-space class="v-mr-auto">
            <span class="font-xs">
              <a-badge class="ant-badge-square" color="#cc0504" text="任务" />
            </span>
            <span class="font-xs">
              <a-badge class="ant-badge-square" color="#3f51b5" text="会议" />
            </span>
          </a-space>
          <a-space>
            <a-button
              size="small"
              outline
              type="default"
              icon="left"
              onClick={() => {
                const newValue = value.clone()
                newValue.add(-1, 'months')
                onChange(newValue)
              }}></a-button>
            <a-date-picker
              size="small"
              mode="year"
              placeholder="选择年份"
              allowClear={false}
              value={String(year)}
              format="YYYY年"
              value-format="YYYY"
              style="width: 62px"
              open={vm.showYearPanel}
              onOpenChange={status => {
                vm.showYearPanel = status
              }}
              onPanelChange={(date, mode) => {
                if (!mode) {
                  const newValue = value.clone()
                  newValue.year(date.year())
                  vm.showYearPanel = false
                  onChange(date)
                }
              }}>
              <a-button block size="small">
                {year}年
              </a-button>
            </a-date-picker>
            <a-select
              size="small"
              style="width: 61px"
              dropdownMatchSelectWidth={false}
              value={String(month)}
              onChange={selectedMonth => {
                const newValue = value.clone()
                newValue.month(parseInt(selectedMonth, 10))
                onChange(newValue)
              }}>
              {monthOptions}
            </a-select>
            <a-button
              size="small"
              outline
              type="default"
              icon="right"
              onClick={() => {
                const newValue = value.clone()
                newValue.add(1, 'months')
                onChange(newValue)
              }}></a-button>
          </a-space>
        </div>
      )
    },
  },
  mounted() {
    this.init()
  },
}
</script>
